import { Container, Box, useMediaQuery, Grid, Button } from '@mui/material';
import React, { useContext, useState, useEffect, useRef, useCallback } from 'react';
import getConfig from 'next/config';
import { useApolloClient } from '@apollo/client';
import { useTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeftRounded';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
// eslint-disable-next-line import/no-unresolved
import { SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import SwiperCarousel from '../shared/SwiperCarousel';
import styles from '../eir-broadband/styles';
import EirOfferCard from '../eir-offer-card/EirOfferCard';
import EirInformation from '../eir-information/EirInformation';
import { getTvTariffs, addTvTariffs, removeTvTariffs } from './Tv.util';
import { displayCart } from '../eir-cart/cart.util';
import RootContext from '../../../util/root.context';
import useLocalStorage, { setCode } from '../../hooks/useLocalStorage';
import { addToCartAnalytics, removeFromCartAnalytics } from '../../../util/gtm';
import EirSingleOfferCard from '../eir-offer-card/EirSingleOfferCard';

import getCarts from '../../integration/cart.api';
import { useToggle } from '../../hooks/useToggle';
import ErrorModal from '../eir-error-modal/ErrorModal';
import EirChannelModal from '../eir-channel-modal/EirChannelModal';
import { getTokenFromCookies, getCookie, setCookie } from '../../hooks/useCookie';
import getGeneralImage from '../../../util/getGeneralImage';
import ApiFailureModal from '../eir-error-modal/ApiFailureModal';
import { formatAfterPrice } from '../../../util/Format.util';
import LoginMain403 from '../eir-403-login/LoginMain403';
import SessionExpireModal from '../eir-session-expire-modal/sessionExpireModal';

const { publicRuntimeConfig } = getConfig();

const TvOfferCardContainer = ({
  cmsData,
  id,
  loading,
  setLoading,
  isPrequaled,
  showTv,
  contractDuration,
  OfferCode,
  nextStep,
  isCO = false,
  setShowNext,
  hasAddons,
}) => {
  const [tvData, setTvData] = useState();
  const [offerSelected, setOfferSelected] = useState(null);
  const [leftArrowDisabled, setLeftArrowDisabled] = useState(true);
  const [RightArrowDisabled, setRightArrowDisabled] = useState(false);
  const openAPIFailureModal = useToggle(false);
  const [errorModalOccurence, setErrorModalOccurence] = useState(0);
  const errorModalMaxOccurence = 2;
  const errorBBModal = useToggle(false);
  const eirChannelModal = useToggle(false);
  const [openError, setOpenError] = useState(false);
  const [onLoadError, setOnLoadError] = useState(false);
  const graphql = useApolloClient();
  const localStore = useLocalStorage();
  const scrollRef = useRef(null);
  const { state: rootState, dispatch } = useContext(RootContext);
  const theme = useTheme();
  const style = styles(theme);
  const swiperRef = useRef(null);
  const sm = useMediaQuery(theme.breakpoints.down('lg'));
  const md = useMediaQuery(theme.breakpoints.down('md'));
  const xs = useMediaQuery(theme.breakpoints.down('sm'));
  const [showLoader, setShowLoader] = useState(' ');
  const showModal = useToggle(false);
  const showSessionExpiredModal = useToggle(false);

  useEffect(() => {
    const localRepoItems = getCookie('found-403');
    if (localRepoItems === 'true') {
      showModal.enable();
      errorBBModal.disable();
    } else {
      showModal.disable();
    }
    const expiredRepoItems = getCookie('token-missing');
    if (expiredRepoItems === 'true') {
      showSessionExpiredModal.enable();
      errorBBModal.disable();
    } else {
      showSessionExpiredModal.disable();
    }
  });

  const onPrequalTvOffers = async cartData => {
    const result = await getTvTariffs({ graphql, contractDuration, isCO: false, cartData });
    setTvData(result?.map(offer => formatAfterPrice(offer)));
    if (result?.length > 0) {
      setShowNext(false);
      setLoading(false);
    }
  };

  const handleOk = () => {
    openAPIFailureModal.disable();
  };
  /**
   * @name selectTariff - Function for adding selected tariff to the cart
   */
  const selectTariff = async (code, offerCode) => {
    setShowLoader(code);
    try {
      const data = await addTvTariffs(
        graphql,
        code,
        offerCode,
        rootState.cart,
        isCO ? 'CHANGE_OFFER' : '',
        isCO
      );
      if (data != null && !data.error) {
        addToCartAnalytics(data);
        dispatch({ type: 'SET_CART', payload: data });
        displayCart({
          dispatch,
          localStorage: localStore,
          graphql,
          cart: data,
          nextMethod: nextStep,
          disablenNextButton: false,
          showNextButton: false,
        });
        setShowNext(false);
        setOfferSelected(code);
        setShowLoader(' ');
        setErrorModalOccurence(0);
        errorBBModal.disable();
        setOnLoadError(false);
      } else {
        setOnLoadError(false);
        if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
        if (!getCookie('token-missing') && !getCookie('found-403'))
          setErrorModalOccurence(errorModalOccurence + 1);
        if (!getCookie('token-missing') && !getCookie('found-403')) errorBBModal.enable();
        setCookie('ION', 'API_FAILED', 'selectTariff');
        if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
        setShowLoader(' ');
      }
    } catch (err) {
      setOnLoadError(false);
      if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
      if (!getCookie('token-missing') && !getCookie('found-403'))
        setErrorModalOccurence(errorModalOccurence + 1);
      if (!getCookie('token-missing') && !getCookie('found-403')) errorBBModal.enable();
      setCookie('ION', 'API_FAILED', 'selectTariff');
      if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
      setShowLoader(' ');
    }
  };
  /**
   * @name removeTariffs - Function for removing selected tariff from the cart
   */
  const removeTariffs = async code => {
    setShowLoader(code);
    try {
      if (rootState.cart?.offers.length > 0) {
        const offerId = await rootState.cart?.offers?.filter(
          offer => offer?.baseOffer?.serviceGroup === 'TV'
        )[0]?.id;
        if (offerId) {
          const data = await removeTvTariffs(graphql, offerId, isCO ? 'CHANGE_OFFER' : '', isCO);
          if (data != null && !data.error) {
            removeFromCartAnalytics(data);
            dispatch({ type: 'SET_CART', payload: data });
            displayCart({
              dispatch,
              localStorage: localStore,
              graphql,
              cart: data,
              nextMethod: nextStep,
              disablenNextButton: false,
              showNextButton: false,
            });
            setOfferSelected(null);
            setShowLoader(' ');
            setErrorModalOccurence(0);
            errorBBModal.disable();
            setOnLoadError(false);
          } else {
            setOnLoadError(false);
            if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
            if (!getCookie('token-missing') && !getCookie('found-403'))
              setErrorModalOccurence(errorModalOccurence + 1);
            if (!getCookie('token-missing') && !getCookie('found-403')) errorBBModal.enable();
            setCookie('ION', 'API_FAILED', 'removeTariffs');
            if (!getCookie('token-missing') && !getCookie('found-403'))
              openAPIFailureModal.enable();
            setShowLoader(' ');
          }
        }
      }
    } catch (err) {
      setOnLoadError(false);
      if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
      if (!getCookie('token-missing') && !getCookie('found-403'))
        setErrorModalOccurence(errorModalOccurence + 1);
      if (!getCookie('token-missing') && !getCookie('found-403')) errorBBModal.enable();
      setCookie('ION', 'API_FAILED', 'removeTariffs');
      if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
      setShowLoader(' ');
    }
  };
  const handleLeftClick = useCallback(() => {
    if (!swiperRef.current) return;
    swiperRef.current.swiper.slidePrev();
  }, []);

  const handleRightClick = useCallback(() => {
    if (!swiperRef.current) return;
    swiperRef.current.swiper.slideNext();
  }, []);
  const checkArrowsStatus = () => {
    if (swiperRef?.current?.swiper?.isBeginning) {
      setLeftArrowDisabled(true);
      // setRightArrowDisabled(false);
    }
    if (swiperRef?.current?.swiper?.isEnd) {
      // setLeftArrowDisabled(false);
      setRightArrowDisabled(true);
    }
    // if (swiperRef.current.swiper.isBeginning && swiperRef.current.swiper.isEnd) {
    //   setLeftArrowDisabled(true);
    //   setRightArrowDisabled(true);
    // }
    if (!swiperRef?.current?.swiper?.isBeginning) {
      setLeftArrowDisabled(false);
      // setRightArrowDisabled(false);
    }
    if (!swiperRef?.current?.swiper?.isEnd) {
      // setLeftArrowDisabled(false);
      setRightArrowDisabled(false);
    }
  };

  const handleKeydown = e => {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      e.target.click();
    }
  };

  const updatePaginationDots = swiper => {
    const paginationDots = swiper.el?.querySelectorAll('.swiper-pagination-bullet');
    if (!paginationDots || !paginationDots.length) return;

    const activeIndex = swiper.realIndex ?? swiper.activeIndex ?? 0;

    paginationDots.forEach((dot, i) => {
      dot.setAttribute('role', 'button');
      dot.setAttribute('tabindex', '0');

      dot.removeEventListener('keydown', handleKeydown);
      dot.addEventListener('keydown', handleKeydown);

      if (i === activeIndex) {
        dot.setAttribute('aria-label', 'Current plan');
      } else if (i < activeIndex) {
        dot.setAttribute('aria-label', 'Previous plan');
      } else {
        dot.setAttribute('aria-label', 'Next plan');
      }
    });
  };

  useEffect(() => {
    checkArrowsStatus();
  }, [OfferCode]);
  useEffect(() => {
    if (!hasAddons) {
      if (scrollRef.current && tvData?.length > 0) scrollRef.current.scrollIntoView();
    }
  }, [tvData, OfferCode, hasAddons]);

  async function onLoadTV() {
    let variables = {};
    setLoading(true);
    if (isCO || getCookie('MYEIR_BB_ADDED') === 'true') {
      setCode('CO');
      variables = {
        reference: localStore.getLocalStorage('ref') || getCookie('reference'),
        token: getTokenFromCookies(),
        cartType: 'CHANGE_OFFER',
      };
    } else {
      variables = {
        reference: localStore.getLocalStorage('PROSPECTUUID'),
      };
    }

    try {
      const { getCart: cartData } = await getCarts({
        graphql,
        variables,
      });
      // await removeTariffs();
      await onPrequalTvOffers(cartData);
      // dispatch({ type: 'SET_CART', payload: cartData });
      const selectedTVOffer = cartData.offers.filter(
        offer => offer.baseOffer.serviceGroup === 'TV'
      );
      if (selectedTVOffer.length > 0) {
        setShowNext(false);
        setOfferSelected(selectedTVOffer[0].baseOffer.catalogTariffPlanCode);
      }

      setOnLoadError(false);
    } catch (err) {
      setOnLoadError(true);
    }
  }
  useEffect(() => {
    if ((isPrequaled && showTv) || getCookie('MYEIR_BB_ADDED') === 'true') {
      onLoadTV();
    }
  }, [contractDuration]);

  function openDialog() {
    eirChannelModal.enable();
  }

  return (
    <Container sx={{ p: 0, mb: 2 }}>
      {isPrequaled && (
        <Container
          id={id}
          sx={{
            p: 0,
            display: { sm: 'flex', md: 'flex' },
            flexDirection: { sm: 'column', md: 'column' },
            alignItems: { sm: 'center', md: 'center' },
            justifyContent: { sm: 'center', md: 'center' },
            ...styles(theme).tvOfferCardDiv,
          }}
          maxWidth={sm ? 'md' : 'md'}
        >
          {tvData &&
            tvData.length > 0 &&
            cmsData?.EirInformation_Tv_Title?.title?.trim().length > 0 && (
              <Box
                sx={
                  cmsData?.EirInformation_Tv_Title?.title?.trim().length === 0
                    ? styles(theme).tvAltInfo
                    : styles(theme).tvInfo
                }
              >
                <EirInformation
                  title={cmsData?.EirInformation_Tv_Title?.title}
                  description={cmsData?.EirInformation_Tv_Title?.description}
                  style={{
                    title: styles(theme).title,
                    description: { color: theme.palette.primary.textColor3 },
                  }}
                />
              </Box>
            )}
          <Box
            sx={{
              width: { sm: '100%' },
              maxWidth: { sm: '90vw', md: '100%' },
              display: { md: 'flex' },
              justifyContent: { md: 'center' },
              alignItems: { md: 'center' },
              flexDirection: { md: 'row' },
            }}
            ref={scrollRef}
          >
            {!md && leftArrowDisabled && tvData?.length > 1 && (
              <IconButton
                size='small'
                sx={styles(theme).prevArrow}
                onClick={handleLeftClick}
                disableRipple
                disableTouchRipple
              >
                <KeyboardArrowLeftIcon />
              </IconButton>
            )}
            {tvData && ((tvData?.length > 0 && xs) || tvData.length > 1) && (
              <SwiperCarousel
                settings={{
                  className: 'content-carousel-broadband content-carousel-broadband-tv-offer-card',
                  pagination: { enable: true, clickable: true },
                  modules: [Pagination],
                  initialSlide: 0,
                  updateOnWindowResize: true,
                  slidesPerView: 'auto',
                  onSlideChange: swiper => {
                    checkArrowsStatus();
                    updatePaginationDots(swiper);
                  },
                  breakpoints: {
                    320: {
                      slidesPerView: 1,
                    },
                    600: {
                      slidesPerView: 2,
                    },
                    1200: {
                      slidesPerView: 3,
                    },
                  },
                  onAfterInit: swiper => {
                    setTimeout(() => {
                      updatePaginationDots(swiper);
                    }, 100);
                  },
                  onPaginationUpdate: swiper => {
                    updatePaginationDots(swiper);
                  },
                  onBreakpoint: swiper => {
                    updatePaginationDots(swiper);
                  },
                }}
                sliderRef={swiperRef}
                style={style.offerSlider.swiper}
              >
                {loading
                  ? Array(2)
                      .fill()
                      .map((_, index) => (
                        <SwiperSlide key={index}>
                          <EirOfferCard loading index={index} />
                        </SwiperSlide>
                      ))
                  : tvData &&
                    tvData.length > 0 &&
                    tvData.map(
                      (offer, i) =>
                        ((tvData?.length > 0 && xs) || tvData.length > 1) && (
                          <SwiperSlide key={i}>
                            <EirOfferCard
                              slideNumber={i}
                              topTag={offer.topTag}
                              preTitle={offer.preTitle}
                              title={offer.title}
                              headerImage={offer.image}
                              headerImgDescription={offer.headerImgDescription}
                              afterPricePosition={offer.afterPricePosition[0]}
                              priceIncreaseTagline={offer.priceIncreaseTagline}
                              sash={offer.sash}
                              contractLength={offer.contractLength}
                              afterPrice={offer.afterPrice}
                              price={offer.price}
                              noDiscount={offer.noDiscount}
                              description={offer.description}
                              descriptions={offer.descriptions}
                              openDialog={() => {
                                openDialog();
                              }}
                              selectButton={{
                                title: 'Select Offer',
                                action: () =>
                                  offer.code === offerSelected
                                    ? removeTariffs(offer.code)
                                    : selectTariff(offer.code, offer.offerCode),
                              }}
                              offerSelected={offer.code === offerSelected}
                              promotion={offer.promotion}
                              moreInfo={offer.moreInfo}
                              color='secondary'
                              isTv
                              code={offer.code}
                              showLoader={showLoader}
                              tvMobileViewImg={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI_SERVER}${
                                getGeneralImage({
                                  generalImageArray: cmsData?.GeneralImage_Broadband,
                                  key: 'TVMobileView',
                                  view: 'MobileViewImage',
                                }).url
                              }`}
                              cmsData={cmsData}
                            />
                          </SwiperSlide>
                        )
                    )}
              </SwiperCarousel>
            )}
            {loading
              ? Array(1)
                  .fill()
                  .map((_, index) => (
                    <SwiperSlide key={index}>
                      <EirSingleOfferCard loading index={index} />
                    </SwiperSlide>
                  ))
              : tvData &&
                tvData.length > 0 &&
                tvData.length === 1 &&
                !xs &&
                tvData.map((offer, i) => (
                  <Grid key={i} item xs={12}>
                    <EirSingleOfferCard
                      topTag={offer.topTag}
                      preTitle={offer.preTitle}
                      title={offer.title}
                      headerImage={offer.image}
                      singleTariffHeaderImage={offer.singleTariffImage}
                      singleHeaderImgDescription={offer.singleHeaderImgDescription}
                      offerSelected={offer.code === offerSelected}
                      moreInfo={offer.moreInfo}
                      priceIncreaseTagline={offer.priceIncreaseTagline}
                      code={offer.code}
                      loading={loading}
                      sash={offer.sash}
                      description={offer.description}
                      descriptions={offer.descriptions}
                      openDialog={() => {
                        openDialog();
                      }}
                      price={offer.price}
                      contractLength={offer.contractLength}
                      afterPrice={offer.afterPrice}
                      noDiscount={offer.noDiscount}
                      index={i}
                      selectButton={{
                        title: 'Select Offer',
                        action: () =>
                          offer.code === offerSelected
                            ? removeTariffs(offer.code)
                            : selectTariff(offer.code, offer.offerCode),
                      }}
                      color='secondary'
                      showLoader={showLoader}
                      isTv
                    />
                  </Grid>
                ))}
            {!md && RightArrowDisabled && tvData?.length > 1 && (
              <IconButton
                size='small'
                sx={styles(theme).nextArrow}
                onClick={handleRightClick}
                disableRipple
                disableTouchRipple
              >
                <KeyboardArrowRightIcon />
              </IconButton>
            )}
          </Box>
        </Container>
      )}
      {tvData && tvData.length > 0 && (
        <Grid item xs={12} sx={styles(theme).submitCTAContainerBroadband}>
          <Button
            variant='buttonMedium'
            sx={{
              ...styles(theme).submitCTAbroadband,
              ...{ fontColor: theme.palette.primary.buttonColor },
            }}
            onClick={() => {
              nextStep();
            }}
            aria-label='Proceed to give details of your current service'
          >
            Next
            <ArrowForwardIcon sx={{ ml: 1 }} />
          </Button>
        </Grid>
      )}
      {openError && errorModalOccurence > errorModalMaxOccurence && (
        <ApiFailureModal openAPIFailureModal={openAPIFailureModal} handleOk={handleOk} />
      )}
      {showModal.value && <LoginMain403 />}
      {showSessionExpiredModal !== undefined && showSessionExpiredModal.value && (
        <SessionExpireModal confirmLogOut={showSessionExpiredModal} />
      )}
      {errorBBModal.value && !showModal.value && !showSessionExpiredModal.value && (
        <ErrorModal
          errorBBModal={errorBBModal}
          occurences={errorModalMaxOccurence}
          currentOccurence={errorModalOccurence}
          ctaMethod={onLoadError ? onLoadTV : () => {}}
        />
      )}
      {/* to enable, do eirChannelModal.enable() */}
      {eirChannelModal.value && (
        <EirChannelModal
          heading='eir TV'
          id='channel-modal'
          open={eirChannelModal.value}
          handleClose={eirChannelModal.disable}
          disableCloseOnBackdropClick={false}
          disableCloseOnEscapeKeyDown={false}
          tvChannels={cmsData?.TVChannels}
        />
      )}
    </Container>
  );
};

export default TvOfferCardContainer;
